import React, {useState} from 'react';
import { NavLink } from 'react-router-dom';

import defaultMedicSvg from '../../../../../assets/img/next/svg/medic.svg';

import Photo from './photo';

import DesktopSchedule from './schedule/DesktopSchedule';
import useDoctorApi from '../../../../doctorPage/common/Doctor/api';
import Appointment from '../../../../../containers/Appointment';
import { Modal } from 'react-bootstrap';
import DoctorPage from '../../../../../containers/DoctorPage';
import { isMobile } from '../../../../../utils/mobile';

import { useDispatch } from 'react-redux';

export default function Doctor({
  doctorSchedule,
  doctor,
  full_name,
  job,
  photo,
  jobDoctorScheduleDays,
  jobDoctorScheduleSlots,
  searchFilters,
  setSearchFilters,
  isVaccinates = false,
  isOperator = false,
  disableOwnLink = false,
  websiteCovidSource = null,
  patients,
  loading,
  user,
}) {
  
  const dispatch = useDispatch();

  const {
    timeSlot,
    setTimeSlot,
    isDirect,
  } = useDoctorApi({ jobs: job ? [job] : [] }); // Pass job as an array for compatibility
 
  const [showDoctorModal, setShowDoctorModal] = useState(false);
 
  const [docСalendarDate, setDocСalendarDateState] = useState(null);
  
  // Custom function that updates date state and opens the modal
  const setDocСalendarDate = (date) => {
    setDocСalendarDateState(date);
    handleLinkClick();
  };

  const handleLinkClick = (e) => {
    if(e) e.preventDefault();
    if(doctor.id !== doctorSchedule?.data[0]?.id) {
      dispatch({ type: 'RESET_DOCTOR_SCHEDULES' });
      dispatch({ type: 'RESET_DOCTORS_BY_DAYS_SCHEDULES' });
    }
    setShowDoctorModal(true);
  };
  
  return (
    <div className="feature-card__item">
      <Appointment
        isOperator={isOperator}
        isVaccinates={isVaccinates}
        websiteCovidSource={websiteCovidSource}
        doctor={doctor}
        job={job}
        timeSlot={timeSlot}
        isOpen={!!timeSlot}
        onClose={() => setTimeSlot(null)}
        jobDoctorScheduleDays={jobDoctorScheduleDays}
        searchFilters={searchFilters}
      />

      {showDoctorModal && (
        <Modal style={{ zIndex: 1030 }} backdropClassName="custom-backdrop" show={showDoctorModal} onHide={() => setShowDoctorModal(false)} centered className="doctor-modal">
          <Modal.Header closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <DoctorPage
              doctorId={doctor.id}
              currentjobId={job?.id}
              medicalServicesId={job?.medical_services_id}
              currentDate={docСalendarDate}
              user={user}
              patients={patients ? { data: patients } : undefined}
              isModal={true}
              onClose={() => { setShowDoctorModal(false); dispatch({ type: 'HIDE_ALERT_MESSAGE' }); }}
              jobDoctorScheduleDays={jobDoctorScheduleDays}
              searchFilters={searchFilters}
            />
          </Modal.Body>
        </Modal>
      )}

      <div className="medic-feature-profile">
        <div className="medic-feature-profile-status">
          <Photo photo={photo} defaultPhoto={defaultMedicSvg} />
        </div>

        <div className="medic-feature-profile-information">
          <div className="medic-feature-profile-information__title">
            <NavLink
              to={`/city/${job.institution.city_id}/doctors/${doctor.id}?job_id=${job?.id}${job?.medical_services_id ? `&medical_service_id=${job?.medical_services_id}` : ''}${searchFilters?.visit_date ? `&calendar_date=${searchFilters.visit_date}` : ''}`}
              disabled={disableOwnLink}
              onClick={handleLinkClick}
              className={`${disableOwnLink ? 'disabled' : ''}`}
            >
              {full_name}
            </NavLink>
          </div>
          {(
              <div className="job-location-title">
                  {/* <span 
                    onClick={() => {
                      setSearchFilters((prev) => ({...prev, institution_id: job.institution.id}));
                    }}
                  >
                    {job.institution.name}
                  </span> */}
                  <NavLink
                    // to={`/city/${job.institution.city_id}/hospitals/${job.institution.id}?division_id=${job?.division?.id || ''}`}
                    // target="_blank"
                    to={`/city/${job.institution.city_id}/doctors/${doctor.id}?job_id=${job?.id}${job?.medical_services_id ? `&medical_service_id=${job?.medical_services_id}` : ''}${searchFilters?.visit_date ? `&calendar_date=${searchFilters.visit_date}` : ''}`}
                    disabled={disableOwnLink}
                    onClick={handleLinkClick}
                    className={`${disableOwnLink ? 'disabled' : ''}`}
                  >
                    {job.institution.name}
                  </NavLink>

                  {job?.doctor?.rank_name != '' && (
                    <div>
                      {job.doctor.rank_name}
                    </div>
                  )}
              </div>
          )}
        </div>
      </div>
      <DesktopSchedule
        key={`${doctor.id}-${job.id}`}
        doctor={doctor}
        job={job}
        onOpenAppointment={setTimeSlot}
        
        datesRange={doctorSchedule.datesRange}
        jobDoctorScheduleSlots={jobDoctorScheduleSlots}
        jobDoctorScheduleDays={jobDoctorScheduleDays}
        loading={loading}
        
        isDirect={isDirect}
        setDocСalendarDate={setDocСalendarDate}
        searchFilters={searchFilters}
        patients={patients}
        style={{ flex: 1 }}
      />
      <div className="medic-feature-profile-price price-column">
        {isMobile() && (<span className="mobile-price-label">Вартість візиту:&nbsp;</span>)}{new Intl.NumberFormat('uk-UA', { maximumFractionDigits: 0 }).format(job.medical_services_price)} грн
      </div>
    </div>
  );
}
